import React from "react";
import TotalClicksIcon from "../../../assets/icons/TotalClicks.svg";
import TotalSignupsIcon from "../../../assets/icons/TotalSignups.svg";
import ActiveReferralsIcon from "../../../assets/icons/ActiveReferals.svg";
import TotalEarningsIcon from "../../../assets/icons/TotalEarnings.svg";

const stats = [
  {
    label: "Total Clicks",
    value: "247",
    icon: TotalClicksIcon,
    iconBg: "bg-statsBlue/10",
    iconRing: "ring-statsBlue",
  },
  {
    label: "Total Signups",
    value: "12",
    icon: TotalSignupsIcon,
    iconBg: "bg-statsGreen/10",
    iconRing: "ring-statsGreen",
  },
  {
    label: "Active Referrals",
    value: "8",
    icon: ActiveReferralsIcon,
    iconBg: "bg-purple/10",
    iconRing: "ring-purple",
  },
  {
    label: "Total Earnings",
    value: "$400",
    icon: TotalEarningsIcon,
    iconBg: "bg-statsOrange/10",
    iconRing: "ring-statsOrange",
  },
];

const StatsGrid = ({ statsData }) => {
  const renderedStats = Array.isArray(statsData) && statsData.length
    ? stats.map((defaultStat) => {
        const liveStat = statsData.find((item) => item?.label === defaultStat.label);
        return {
          ...defaultStat,
          ...(liveStat || {}),
        };
      })
    : stats;

  return (
  <div className="w-full mt-6 grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4">
    {renderedStats.map((stat, idx) => (
      <div
        key={idx}
        className="bg-white rounded-lg border border-line px-6 sm:px-8 py-9 sm:py-11 flex items-center justify-between gap-4 min-w-[200px] hover:scale-[1.01] transition-all duration-300 hover:bg-primary/5"
        style={{
          boxShadow: "0px 1px 2px -1px #0000001A, 0px 1px 3px 0px #0000001A",
        }}
      >
        <div>
          <div className="text-2xl font-bold text-content leading-tight">
            {stat.value}
          </div>
          <div className="text-sm text-content font-semibold">{stat.label}</div>
        </div>
        <div
          className={`flex items-center justify-center rounded-full h-10 sm:h-12 w-10 sm:w-12 ${stat.iconBg} ${stat.iconRing} ring-2`}
        >
          <img
            src={stat.icon}
            alt={stat.label}
          />
        </div>
      </div>
    ))}
  </div>
  );
};

export default StatsGrid;
